import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MustMatch } from '../utils/must-match.validator';
import { ResetPasswordRequest } from 'auth-api'; 
import { CommonService } from 'src/app/common.service';
import { ConfigurationVariablesList } from 'std-api';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  loading = false;
  error = 'no_error';
  resetPasswordForm: FormGroup;
  ticket: string;
  done = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService
  ) { }

  ngOnInit() {

    this.resetPasswordForm = this.formBuilder.group({
      password: new FormControl('', [Validators.required]),
      passwordConfirm: new FormControl('', [Validators.required])
    }, {
      validator: MustMatch('password', 'passwordConfirm')
    });

    this.ticket = this.route.snapshot.queryParams['ticket'];
    console.log("Ticket : "  + this.route.snapshot.queryParams['ticket']);
  }

  resetPasswordSubmitHandler() {
    this.resetError();
    this.loading = true;
    if (!this.resetPasswordForm.valid) {
      this.error = "I campi non sono compilati correttamente";
      const controls = this.resetPasswordForm.controls;
      Object.keys(controls).forEach(controlName => controls[controlName].markAsDirty());
      console.log("Invalid Form");
      this.loading = false;
      return;
    }

    let resetPasswordRequest: ResetPasswordRequest = {
      newPassword: this.resetPasswordForm.value.password,
      resetPasswordTicket: this.ticket
    }

    this.commonService.getRegistrationService().authResetPasswordPost(resetPasswordRequest).subscribe(
      (data) => {
        this.done = true;
        console.log(data);
      },
      error => {
        console.log(error);
        var err = error.error.errors[0].text;
        if (err === 'PASSWORD_NOT_FULFILLING_POLICIES') {
          //this.registrationError = 'La password deve contenere almeno una lettera maiuscola, deve contenere almeno un numero, deve contenere almeno una lettera minuscola, deve essere lunga almeno 8 caratteri';
          this.getPasswordPolicyMessage();
        } else
        if (('status' in error) && (error.status==403)) {
          this.error = "Token invalido o già utilzzato, ripeti la procedura di recupero.";
        } else  { 
          this.error = "Qualcosa non ha funzionato";
        }        
      }
    );


    console.log(this.resetPasswordForm.value);
    this.loading = false;
  }

  resetError() {
    this.error = 'no_error';
  }

  getPasswordPolicyMessage() {
    this.commonService.getConfigurationVariables().then(
      (variables:ConfigurationVariablesList) => {
        console.log('PASSWORD_POLICY_MESSAGE: ' + variables['PASSWORD_POLICY_MESSAGE']);
        this.error =  variables['PASSWORD_POLICY_MESSAGE'];
      }
    );
  }
}
